var map = {
	"./DummyData/data": "3039",
	"./DummyData/data.json": "3039",
	"./css/responsive.css": "f176",
	"./img/art-work/1.png": "35f1",
	"./img/art-work/11.png": "e86c",
	"./img/art-work/2.png": "ad24",
	"./img/art-work/3.png": "1c71",
	"./img/art-work/4.png": "8ccd",
	"./img/art-work/5.png": "b0d9",
	"./img/art-work/6.png": "4eb4",
	"./img/art-work/7.png": "4c05",
	"./img/art-work/8.png": "d657",
	"./img/art-work/9.png": "87c6",
	"./img/art-work/c1.png": "a21e",
	"./img/art-work/c2.png": "e5ac",
	"./img/art-work/c3.png": "e8a6",
	"./img/art-work/c4.png": "4dd4",
	"./img/art-work/detailed.jpg": "ace0",
	"./img/art-work/fire.png": "4b14",
	"./img/art-work/profile-header.jpg": "56f3",
	"./img/art-work/virus1.png": "9151",
	"./img/art-work/virusbanner.png": "87be",
	"./img/authors/1.png": "0144",
	"./img/authors/10.png": "0279",
	"./img/authors/11.png": "e369",
	"./img/authors/12.png": "0fa1",
	"./img/authors/2.png": "1dfb",
	"./img/authors/3.png": "465e",
	"./img/authors/4.png": "41d2",
	"./img/authors/5.png": "a7f6",
	"./img/authors/6.png": "f4fb",
	"./img/authors/7.png": "754a",
	"./img/authors/8.png": "76b3",
	"./img/authors/9.png": "17ed",
	"./img/bg-img/bread.png": "1542",
	"./img/bg-img/header-1.jpg": "e054",
	"./img/bg-img/header-1.png": "1d57",
	"./img/bg-img/roadmap-banner.png": "ef76",
	"./img/blog-img/1.jpg": "4f19",
	"./img/blog-img/2.jpg": "2e5b",
	"./img/blog-img/3.jpg": "27e8",
	"./img/core-img/android-chrome-192x192.png": "5071",
	"./img/core-img/android-chrome-512x512.png": "d57c",
	"./img/core-img/apple-touch-icon.png": "e9f4",
	"./img/core-img/cfi.png": "6079",
	"./img/core-img/crypto.png": "4633",
	"./img/core-img/demologo.png": "b3fe",
	"./img/core-img/dots.png": "efed",
	"./img/core-img/favicon-16x16.png": "a3fc",
	"./img/core-img/favicon-32x32.png": "e6ee",
	"./img/core-img/favicon.ico": "4836",
	"./img/core-img/favicon.png": "c598",
	"./img/core-img/logo.png": "480b",
	"./img/core-img/map-pattern-footer.png": "0f72",
	"./img/core-img/pattern.png": "2384",
	"./img/core-img/platform.png": "b7bb",
	"./img/core-img/portal.jpg": "6571",
	"./img/core-img/pwa.png": "a46f",
	"./img/core-img/rain.png": "40c6",
	"./img/core-img/rain1.png": "4166",
	"./img/core-img/rings.png": "74d8",
	"./img/core-img/shower.png": "e24c",
	"./img/core-img/site.webmanifest": "a0b3",
	"./img/icons/f1.png": "1798",
	"./img/icons/f2.png": "1996",
	"./img/icons/f3.png": "7efc",
	"./img/icons/f4.png": "edff",
	"./img/icons/f5.png": "80ed",
	"./img/icons/f6.png": "c49a",
	"./img/icons/f7.png": "5580",
	"./img/icons/w1.png": "77a6",
	"./img/icons/w2.png": "164d",
	"./img/icons/w3.png": "c7b7",
	"./img/icons/wallet.png": "1eb7",
	"./img/team/andy.png": "a64c",
	"./img/team/brian.png": "33f9",
	"./img/team/encore.png": "54d7",
	"./img/team/encore1.png": "cfe5",
	"./img/team/keith.png": "0a29",
	"./img/team/lolabunny.png": "f45b",
	"./img/team/lolabunny2.png": "9295",
	"./img/team/princeton.png": "3cac",
	"./img/team/supadog.png": "9d22",
	"./img/team/supadog3.png": "e402",
	"./img/team/timestream.png": "fa18",
	"./img/team/timestream4.png": "83b7",
	"./img/test-img/1.jpg": "0579",
	"./img/test-img/2.jpg": "479e",
	"./img/test-img/3.jpg": "83f9",
	"./logo.png": "cf05",
	"./logodemo.png": "d689"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";